import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

//Import Pages
import DashNav from "./components/CompainedComponent";
import Dashboard from "./components/Dashboard";
import BottleReturnDashboard from "./components/Forms/BottleReturn";
import BottleReturnForm from "./components/Forms/BottleReturn/BottleReturnForm";
import CategoryDashboard from "./components/Forms/Category";
import CategoryForm from "./components/Forms/Category/CategoryForm";
import CustomerDashboard from "./components/Forms/Customer";
import CustomerForm from "./components/Forms/Customer/CustomerForm";
import CustomerAccDashboard from "./components/Forms/CustomerAccountManagement";
import CustomerAccForm from "./components/Forms/CustomerAccountManagement/CustomerAccountManagementForm";
import CustomerFeedbackDashboard from "./components/Forms/CustomerFeedback";
import CustomerFeedbackForm from "./components/Forms/CustomerFeedback/CustomerFeedbackForm";
import DamageDashboard from "./components/Forms/Damage";
import DamageForm from "./components/Forms/Damage/DamageForm";
import InvoiceDashboard from "./components/Forms/Invoice";
import Invoice from "./components/Forms/Invoice/InvoiceForm";
import LoginForm from "./components/LoginForm";
import ProductDashboard from "./components/Forms/Product";
import ProductForm from "./components/Forms/Product/ProductForm";
import PromotionDashboard from "./components/Forms/Promotion";
import PromotionForm from "./components/Forms/Promotion/PromotionForm";
import PurchaseDashboard from "./components/Forms/PurchaseDetail";
import PurchaseForm from "./components/Forms/PurchaseDetail/PurchaseForm";
import RoleDashboard from "./components/Forms/Role";
import CreateRole from "./components/Forms/Role/CreateRole";
import StaffDashboard from "./components/Forms/Staff";
import StaffForm from "./components/Forms/Staff/StaffForm";
import SupplierDashboard from "./components/Forms/Supplier";
import SupplierForm from "./components/Forms/Supplier/SupplierForm";
import SupplierFeedbackDashboard from "./components/Forms/SupplierFeedback";
import SupplierFeedbackForm from "./components/Forms/SupplierFeedback/SupplierFeedbackForm";
import UserDashboard from "./components/Forms/User";
import UserForm from "./components/Forms/User/UserForm";
import UserView from "./components/Forms/User/UserView";
import WorkFlowDashboard from "./components/Forms/WorkFlow";
import WorkFlowForm from "./components/Forms/WorkFlow/WorkFlowForm";
import NotFound from "./util/Notfound";
import StaffView from "./components/Forms/Staff/StaffView";
import CustomerView from "./components/Forms/Customer/CustomerView";
import SupplierView from "./components/Forms/Supplier/SupplierView";
import ProductView from "./components/Forms/Product/ProductView";
import PurchaseView from "./components/Forms/PurchaseDetail/PurchaseView";
import { useContext, useEffect } from "react";
import { GlobalState } from "./GlobalState";
import axios from "./helpers/axios";
import InvoiceView from "./components/Forms/Invoice/invoiceView";
import ForgotPassword from "./components/LoginForm/ForgotPassword";
import OrderDashboard from "./components/Forms/Order";
import OrderedProductView from "./components/Forms/Order/OrderedProduct";

const ProtectedRoute = ({ element }) => {
  const isUser = localStorage.getItem("login");
  return isUser ? element : <Navigate to="/" replace />;
};

function App() {
  const state = useContext(GlobalState);
  const [expiredPromotion] = state.promotionAPI.expiredPromotion;

  const isUser = localStorage.getItem("login");

  useEffect(() => {
    if (!isUser) return;

    expiredPromotion.map((promo) => {
      axios.put(`/promotion/delete-expire/${promo.id}`);
    });
  }, [expiredPromotion, isUser]);

  return (
    <div className="container">
      <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <Routes>
          <Route exact path="/*" element={<NotFound />} />
          <Route exact path="/" element={<LoginForm />} />
          <Route exact path="/forgotpassword" element={<ForgotPassword />} />
          <Route exact path="/dashboard" element={<ProtectedRoute element={<DashNav component={<Dashboard />} />} />} />

          <Route exact path="/user" element={<ProtectedRoute element={<DashNav component={<UserDashboard />} />} />} />
          <Route exact path="/user-form" element={<ProtectedRoute element={<DashNav component={<UserForm />} />} />} />
          <Route exact path="/user-form/:userId" element={<ProtectedRoute element={<DashNav component={<UserForm />} />} />} />
          <Route exact path="/user-view/:userId" element={<ProtectedRoute element={<DashNav component={<UserView />} />} />} />

          <Route exact path="/role" element={<ProtectedRoute element={<DashNav component={<RoleDashboard />} />} />} />
          <Route exact path="/role-form" element={<ProtectedRoute element={<DashNav component={<CreateRole />} />} />} />
          <Route exact path="/role-form/:roleId" element={<ProtectedRoute element={<DashNav component={<CreateRole />} />} />} />

          <Route exact path="/bottle-return" element={<ProtectedRoute element={<DashNav component={<BottleReturnDashboard />} />} />} />
          <Route exact path="/bottle-return-form" element={<ProtectedRoute element={<DashNav component={<BottleReturnForm />} />} />} />
          <Route exact path="/bottle-return-form/:returnId" element={<ProtectedRoute element={<DashNav component={<BottleReturnForm />} />} />} />

          <Route exact path="/category" element={<ProtectedRoute element={<DashNav component={<CategoryDashboard />} />} />} />
          <Route exact path="/category-form" element={<ProtectedRoute element={<DashNav component={<CategoryForm />} />} />} />
          <Route exact path="/category-form/:categoryId" element={<ProtectedRoute element={<DashNav component={<CategoryForm />} />} />} />

          <Route exact path="/customer-account" element={<ProtectedRoute element={<DashNav component={<CustomerAccDashboard />} />} />} />
          <Route exact path="/customer-account-form" element={<ProtectedRoute element={<DashNav component={<CustomerAccForm />} />} />} />
          <Route exact path="/customer-account-form/:cusId" element={<ProtectedRoute element={<DashNav component={<CustomerAccForm />} />} />} />

          <Route exact path="/customer-feedback" element={<ProtectedRoute element={<DashNav component={<CustomerFeedbackDashboard />} />} />} />
          <Route exact path="/customer-feedback-form" element={<ProtectedRoute element={<DashNav component={<CustomerFeedbackForm />} />} />} />
          <Route exact path="/customer-feedback-form/:cusId" element={<ProtectedRoute element={<DashNav component={<CustomerFeedbackForm />} />} />} />

          <Route exact path="/customer" element={<ProtectedRoute element={<DashNav component={<CustomerDashboard />} />} />} />
          <Route exact path="/customer-form" element={<ProtectedRoute element={<DashNav component={<CustomerForm />} />} />} />
          <Route exact path="/customer-form/:customerId" element={<ProtectedRoute element={<DashNav component={<CustomerForm />} />} />} />
          <Route exact path="/customer-view/:customerId" element={<ProtectedRoute element={<DashNav component={<CustomerView />} />} />} />

          <Route exact path="/damage" element={<ProtectedRoute element={<DashNav component={<DamageDashboard />} />} />} />
          <Route exact path="/damage-form" element={<ProtectedRoute element={<DashNav component={<DamageForm />} />} />} />
          <Route exact path="/damage-form/:damId" element={<ProtectedRoute element={<DashNav component={<DamageForm />} />} />} />

          <Route exact path="/invoice" element={<ProtectedRoute element={<DashNav component={<InvoiceDashboard />} />} />} />
          <Route exact path="/invoice-view/:invId" element={<ProtectedRoute element={<DashNav component={<InvoiceView />} />} />} />
          <Route exact path="/billing" element={<ProtectedRoute element={<DashNav component={<Invoice />} />} />} />

          <Route exact path="/product" element={<ProtectedRoute element={<DashNav component={<ProductDashboard />} />} />} />
          <Route exact path="/product-form" element={<ProtectedRoute element={<DashNav component={<ProductForm />} />} />} />
          <Route exact path="/product-form/:productId" element={<ProtectedRoute element={<DashNav component={<ProductForm />} />} />} />
          <Route exact path="/product-view/:productId" element={<ProtectedRoute element={<DashNav component={<ProductView />} />} />} />

          <Route exact path="/promotion" element={<ProtectedRoute element={<DashNav component={<PromotionDashboard />} />} />} />
          <Route exact path="/promotion-form" element={<ProtectedRoute element={<DashNav component={<PromotionForm />} />} />} />
          <Route exact path="/promotion-form/:promotionId" element={<ProtectedRoute element={<DashNav component={<PromotionForm />} />} />} />

          <Route exact path="/purchase" element={<ProtectedRoute element={<DashNav component={<PurchaseDashboard />} />} />} />
          <Route exact path="/purchase-form" element={<ProtectedRoute element={<DashNav component={<PurchaseForm />} />} />} />
          <Route exact path="/purchase-form/:purchaseId" element={<ProtectedRoute element={<DashNav component={<PurchaseForm />} />} />} />
          <Route exact path="/purchase-view/:purchaseId" element={<ProtectedRoute element={<DashNav component={<PurchaseView />} />} />} />

          <Route exact path="/staff" element={<ProtectedRoute element={<DashNav component={<StaffDashboard />} />} />} />
          <Route exact path="/staff-form" element={<ProtectedRoute element={<DashNav component={<StaffForm />} />} />} />
          <Route exact path="/staff-form/:staffId" element={<ProtectedRoute element={<DashNav component={<StaffForm />} />} />} />
          <Route exact path="/staff-view/:staffId" element={<ProtectedRoute element={<DashNav component={<StaffView />} />} />} />

          <Route exact path="/supplier-feedback" element={<ProtectedRoute element={<DashNav component={<SupplierFeedbackDashboard />} />} />} />
          <Route exact path="/supplier-feedback-form" element={<ProtectedRoute element={<DashNav component={<SupplierFeedbackForm />} />} />} />
          <Route exact path="/supplier-feedback-form/:supId" element={<ProtectedRoute element={<DashNav component={<SupplierFeedbackForm />} />} />} />

          <Route exact path="/supplier" element={<ProtectedRoute element={<DashNav component={<SupplierDashboard />} />} />} />
          <Route exact path="/supplier-form" element={<ProtectedRoute element={<DashNav component={<SupplierForm />} />} />} />
          <Route exact path="/supplier-form/:supplierId" element={<ProtectedRoute element={<DashNav component={<SupplierForm />} />} />} />
          <Route exact path="/supplier-view/:supplierId" element={<ProtectedRoute element={<DashNav component={<SupplierView />} />} />} />

          <Route exact path="/workflow" element={<ProtectedRoute element={<DashNav component={<WorkFlowDashboard />} />} />} />
          <Route exact path="/workflow-form" element={<ProtectedRoute element={<DashNav component={<WorkFlowForm />} />} />} />
          <Route exact path="/workflow-form/:workflowId" element={<ProtectedRoute element={<DashNav component={<WorkFlowForm />} />} />} />

          <Route exact path="/order" element={<ProtectedRoute element={<DashNav component={<OrderDashboard />} />} />} />
          <Route exact path="/ordered-product/:orId" element={<ProtectedRoute element={<DashNav component={<OrderedProductView />} />} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
